import { render } from "./TechWorksPlaceholder.vue?vue&type=template&id=5b8db56a&scoped=true&ts=true"
import script from "./TechWorksPlaceholder.vue?vue&type=script&lang=ts"
export * from "./TechWorksPlaceholder.vue?vue&type=script&lang=ts"

import "./TechWorksPlaceholder.vue?vue&type=style&index=0&id=5b8db56a&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8db56a"]])

export default __exports__